import React from 'react';
import { observer } from 'mobx-react';
import { FormGroup, FormControl } from 'react-bootstrap';

export const NotificationTypeDropdown = observer(({ notificationTypes, notificationCode, setNotificationType }) => {
  const onChange = (event) => {
    setNotificationType(event.target.value);
  };

  return (
    <FormGroup controlId="notificationTypeSelect">
      <FormControl componentClass="select"
        value={notificationCode}
        onChange={onChange}
      >
        <option value='' key={0}>All Notification Types</option>
        {notificationTypes.map(type => <option value={type.name} key={type.id}>{type.name}</option>)}
      </FormControl>
    </FormGroup>
  );
});
